import { TipoIdentificacion } from "./tipo-identificacion";

export class Persona {
    usu_id: number;
	codigo: number;
	identificacion: string;
	tipoIdentificacion: TipoIdentificacion;
	municipio: string;
	apellido: string;
	nombre: string;
	programa: string;
	email: string;
	emailInterno: string;
}
